<!-- eslint-disable vue/no-static-inline-styles -->
<script lang="ts" setup>
import useFeatureTourStore from '@/stores/feature-tour';
import ConnxTab from '@/components/Molecules/ConnxTab.vue';
import ConnxTabs from '@/components/Molecules/ConnxTabs.vue';

const featureTourStore = useFeatureTourStore();
// import ConnxHrAdminWorkforceAssistanceReportsUploadTab from './ConnxHrAdminWorkforceAssistanceReportsUploadTab.vue';
import ConnxHrAdminWorkforceAssistanceInformationTab from './ConnxHrAdminWorkforceAssistanceInformationTab.vue';

import ConnxHrAdminWorkforceAssistanceReportsTab from './ConnxHrAdminWorkforceAssistanceReportsTab.vue';

const activeTab = featureTourStore.featureSeen('WorkforceAssistanceReport') ? null : 'Information';
</script>

<template>
  <div>
    <connx-tabs
      :active-tab="activeTab"
      tab-container-class="tw-h-container"
    >
      <connx-tab
        name="Report Generation"
        class="tw-h-full tw-pt-4"
      >
        <connx-hr-admin-workforce-assistance-reports-tab />
      </connx-tab>
      <connx-tab
        name="Information"
        class="tw-h-full tw-pt-4"
      >
        <ConnxHrAdminWorkforceAssistanceInformationTab />
      </connx-tab>
      <!-- <connx-tab name="Field Configuration">
        <connx-hr-admin-workforce-assistance-reports-upload-tab />
      </connx-tab> -->
    </connx-tabs>
  </div>
</template>
